// @ts-nocheck

import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { get } from 'lodash'
import debounce from 'lodash/debounce'

import { Modal } from 'reactstrap'
import NotificationSystem from 'rc-notification'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { trackAddedEvent, campaignDetailsEvent } from 'Helpers/tagManager'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import { ModalHeader } from 'Stories/ModalHeader/ModalHeader.stories'

import closeCross from 'Shared/icons/close-cross.svg'
import { FullWideNotification } from 'Shared/components/Notification'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import CustomScrollDiv from 'Shared/custom/CustomScrollDiv'

import {
  getSpotifyTrack as onGetSpotifyTrack,
  getSpotifyTracks as onGetSpotifyTracks,
  setTracksToInitialState,
} from 'Redux/actions/trackActions'

import {
  checkAlbumToCreateCampaign as onCheckAlbum,
  checkTrackToCreateCampaign as onCheckTrack,
} from 'Redux/actions/campaignActions'
import { getAmountOfCampaigns } from 'Redux/selectors/campaigns'
import { getIsFirstCampaign, getUserId } from 'Redux/selectors/auth'
import AddSearchTrackForm from '../AddSearchTrackForm'
import CheckTrackFromSearch from '../CheckTrackFromSearch'
import SuccessfulyAddedTrack from '../SuccessfulyAddedTrack'

import { AddSpotifySearchModalProps } from './AddSpotifySearchModalProps'

import {
  ChangeSpotifyBlockDesktop,
  ChangeSpotifyBlockMobile,
  SmallButton,
  SpotifyUrlFormWrapper,
  WrapperForCloseBtn,
  WrapperRelative,
} from './styles'

let notification = null

const showNotification = (errorMessage, top) => {
  notification.notice({
    content: <FullWideNotification color="danger" message={errorMessage} />,
    position: 'full',
    duration: 3,
    closable: true,
    style: { top, left: 0 },
    className: `ltr-support`,
  })
}
// create this component to mobile modal window ~
const AddSpotifySearchModal: FunctionComponent<AddSpotifySearchModalProps> = ({
  accessToken,
  track,
  tracks,
  toggle,
  modal,
  isAuth,
  isChangedTrack,
  setIsChangedTrack,
  searchValue,
  setSearchValue,
  campaignType,
}) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const userId = useSelector(getUserId)
  const isFirstCampaign = useSelector(getIsFirstCampaign)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const campaignNumber = amountOfCampaigns + 1

  const [searchError, setSearchError] = useState(false)
  const [errorAnswerSpotify, setErrorAnswerSpotify] = useState(false)
  const [sameTrackError, setSameTrackError] = useState(false)

  useEffect(() => {
    if (!searchValue) {
      dispatch(setTracksToInitialState())
      setSearchError(false)
      setErrorAnswerSpotify(false)
      setSameTrackError(false)
    }
  }, [searchValue])

  const setGTMevent = track => {
    trackAddedEvent(
      track,
      Boolean(isFirstCampaign),
      campaignType,
      campaignNumber,
      userId
    )
    userId && campaignDetailsEvent(campaignType, campaignNumber)
  }

  const sendTracks = search => {
    if (search.length === 0) return

    if (search.includes('open.spotify.com')) {
      const index = search.indexOf('track')
      const trackID = search
        .substring(index)
        .slice(6)
        .substring(0, 22)
      const apiURL = `https://api.spotify.com/v1/tracks/${trackID}`
      dispatch(
        onGetSpotifyTracks(apiURL, accessToken, error => {
          if (error) {
            const errorMessage = get(error, 'error.message', null)
            if (errorMessage === 'The access token expired') {
              setSearchError(true)
            } else {
              setErrorAnswerSpotify(true)
            }
          } else {
            localStorage.setItem('trackURL', apiURL)
          }
        })
      )
      return
    }

    const apiSearch = `https://api.spotify.com/v1/search?q=${search}&type=artist,track`
    dispatch(
      onGetSpotifyTracks(apiSearch, accessToken, error => {
        if (error) {
          const errorMessage = get(error, 'error.message', null)
          if (errorMessage === 'The access token expired') {
            setSearchError(true)
          } else {
            setErrorAnswerSpotify(true)
          }
        }
      })
    )
  }

  const updateTracks = () => sendTracks(searchValue)
  const delayedTracks = useCallback(debounce(updateTracks, 1000), [searchValue])

  useEffect(() => {
    delayedTracks()
    return delayedTracks.cancel
  }, [searchValue, delayedTracks])

  const handleSubmit = () => {
    const isTrack = searchValue.includes('track')

    if (accessToken && isTrack) {
      const index = searchValue.indexOf('track')
      const trackID = searchValue
        .substring(index)
        .slice(6)
        .substring(0, 22)
      const apiURL = `https://api.spotify.com/v1/tracks/${trackID}`

      if (isAuth) {
        dispatch(
          onCheckTrack(apiURL, error => {
            if (!error) {
              dispatch(
                onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
                  if (error) {
                    const errorMessage = get(error, 'error.message', null)
                    if (errorMessage === 'The access token expired') {
                      setSearchError(true)
                    } else {
                      setErrorAnswerSpotify(true)
                    }
                  } else {
                    setGTMevent(res)

                    localStorage.setItem('trackURL', apiURL)
                  }
                })
              )
            } else {
              setSameTrackError(true)
            }
          })
        )
      } else {
        dispatch(
          onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
            if (error) {
              const errorMessage = get(error, 'error.message', null)
              if (errorMessage === 'The access token expired') {
                setSearchError(true)
              } else {
                setErrorAnswerSpotify(true)
              }
            } else {
              setGTMevent(res)
              localStorage.setItem('trackURL', apiURL)
            }
          })
        )
      }
    } else if (accessToken && !isTrack) {
      const index = searchValue.indexOf('album')
      const albumID = searchValue
        .substring(index)
        .slice(6)
        .substring(0, 22)

      dispatch(
        onCheckAlbum(albumID, error => {
          if (error) {
            NotificationSystem.newInstance(
              { style: { top: 0 } },
              n => (notification = n)
            )
            showNotification(error.errorMessage, 0)
          }
        })
      )
    }
    setSearchValue('')
    dispatch(setTracksToInitialState())
  }

  const handleSetSearchToInitial = () => {
    setSearchValue('')
    dispatch(setTracksToInitialState())
  }

  const handleCheck = apiURL => {
    if (accessToken) {
      if (isAuth) {
        dispatch(
          onCheckTrack(apiURL, error => {
            if (!error) {
              setIsChangedTrack(false)
              dispatch(
                onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
                  if (error) {
                    const errorMessage = get(error, 'error.message', null)
                    if (errorMessage === 'The access token expired') {
                      setSearchError(true)
                    } else {
                      setErrorAnswerSpotify(true)
                    }
                  } else {
                    setGTMevent(res)
                    localStorage.setItem('trackURL', apiURL)
                  }
                })
              )
              handleSetSearchToInitial()
            } else {
              setSameTrackError(true)
              dispatch(setTracksToInitialState())
            }
          })
        )
      } else {
        dispatch(
          onGetSpotifyTrack(apiURL, accessToken, (error, res) => {
            if (error) {
              const errorMessage = get(error, 'error.message', null)
              if (errorMessage === 'The access token expired') {
                setSearchError(true)
              } else {
                setErrorAnswerSpotify(true)
              }
            } else {
              setIsChangedTrack(false)
              setGTMevent(res)
              localStorage.setItem('trackURL', apiURL)
            }
          })
        )
        handleSetSearchToInitial()
      }
    }
  }

  const handleChangeSpotifyTrack = () => {
    setIsChangedTrack(true)
    setSearchError(false)
    setErrorAnswerSpotify(false)
    setSameTrackError(false)
    toggle()
  }

  return (
    <>
      {track ? (
        <>
          <Desktop>
            <ChangeSpotifyBlockDesktop>
              <DottedBtn
                content={t('createCampaignPage.changeSpotifyTrack')}
                onClick={handleChangeSpotifyTrack}
              />
            </ChangeSpotifyBlockDesktop>
          </Desktop>
          <Mobile>
            <ChangeSpotifyBlockMobile>
              <DottedBtn
                content={t('createCampaignPage.changeSpotifyTrack')}
                onClick={handleChangeSpotifyTrack}
              />
            </ChangeSpotifyBlockMobile>
          </Mobile>
        </>
      ) : (
        <WhiteGreenBtn color="whiteGreen" onClick={toggle}>
          {t('createCampaignPage.addSpotifyTrack')}
        </WhiteGreenBtn>
      )}

      <Desktop>
        <Modal
          fade={false}
          className="modal-dialog--success modal-dialog--header search"
          isOpen={modal}
          modalClassName="ltr-support"
          toggle={toggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggle}
            />
            <ModalHeader content={t('createCampaignPage.enterSearchTrack')} />
          </div>

          <SpotifyUrlFormWrapper>
            {!isChangedTrack &&
              (!track ? (
                <AddSearchTrackForm
                  searchValue={searchValue}
                  searchError={searchError}
                  errorAnswerSpotify={errorAnswerSpotify}
                  sameTrackError={sameTrackError}
                  setSearchValue={setSearchValue}
                  onSubmit={handleSubmit}
                />
              ) : (
                <SuccessfulyAddedTrack toggle={toggle} />
              ))}

            {isChangedTrack && (
              <AddSearchTrackForm
                searchValue={searchValue}
                searchError={searchError}
                errorAnswerSpotify={errorAnswerSpotify}
                sameTrackError={sameTrackError}
                setSearchValue={setSearchValue}
                onSubmit={handleSubmit}
              />
            )}

            {tracks && (
              <WrapperRelative>
                <CustomScrollDiv length={tracks.length}>
                  <CheckTrackFromSearch tracks={tracks} onCheck={handleCheck} />
                </CustomScrollDiv>
              </WrapperRelative>
            )}
          </SpotifyUrlFormWrapper>
        </Modal>
      </Desktop>

      <Mobile>
        <Modal
          fade={false}
          className="modal__mobile-dialog"
          isOpen={modal}
          modalClassName="modal__mobile"
          toggle={toggle}
        >
          <div className="spotify-url-form-wrapper">
            <>
              {!isChangedTrack &&
                (!track ? (
                  <>
                    <button
                      className="modal__mobile--close lnr lnr-arrow-left"
                      type="button"
                      onClick={toggle}
                    />
                    <AddSearchTrackForm
                      searchValue={searchValue}
                      searchError={searchError}
                      errorAnswerSpotify={errorAnswerSpotify}
                      sameTrackError={sameTrackError}
                      setSearchValue={setSearchValue}
                      onSubmit={handleSubmit}
                    />
                  </>
                ) : (
                  <SuccessfulyAddedTrack toggle={toggle} />
                ))}
              {isChangedTrack && (
                <>
                  <button
                    className="modal__mobile--close lnr lnr-arrow-left"
                    type="button"
                    onClick={toggle}
                  />
                  <AddSearchTrackForm
                    searchValue={searchValue}
                    searchError={searchError}
                    errorAnswerSpotify={errorAnswerSpotify}
                    sameTrackError={sameTrackError}
                    setSearchValue={setSearchValue}
                    onSubmit={handleSubmit}
                  />
                </>
              )}
              {tracks && (
                <WrapperForCloseBtn>
                  <SmallButton onClick={handleSetSearchToInitial}>
                    <img src={closeCross} alt="clear-button" />
                  </SmallButton>
                </WrapperForCloseBtn>
              )}
            </>

            {tracks && (
              <CustomScrollDiv length={tracks.length}>
                <CheckTrackFromSearch tracks={tracks} onCheck={handleCheck} />
              </CustomScrollDiv>
            )}
          </div>
        </Modal>
      </Mobile>
    </>
  )
}

export default AddSpotifySearchModal
